import HundredBricksAPIError from '../../HundredBricksAPIError';
class ResendPhoneTokenError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('ResendPhoneTokenError', ...args);
    }
}
export default ResendPhoneTokenError;
